import {locationContainer} from '@wallaby-ui/core';
import {debounce, isEmpty, isEqual} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {connect} from 'react-redux';

import SelectHierarchyBox from './SelectHierarchyBox';
import {
  getHierarchyTypes,
  loadStateFromParamsSelector,
} from '../hierarchy_actions';
import {getSearchServiceUrl} from 'src/js/containers/filter_and_search/filter_and_search_selectors';
import {changeParamsAndQuery} from 'src/js/containers/filter_and_search/filter_and_search_thunks';

class SelectHierarchyContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    const {config, hierarchyStateId, hierarchyTypes, filterAndSearchStateId} =
      this.props;
    this.debouncedChangeParamsAndQuery = debounce(
      this.props.changeParamsAndQuery,
      500
    ).bind(this);
    this.handleHierarchyChange = this.handleHierarchyChange.bind(this);

    if (isEmpty(hierarchyTypes) || !hierarchyTypes.isLoaded()) {
      this.props.getHierarchyTypes(
        config.service.url.hierarchyTypes,
        hierarchyStateId,
        filterAndSearchStateId
      );
    } else {
      this.props.loadStateFromParamsSelector(
        hierarchyStateId,
        filterAndSearchStateId
      );
    }
  }

  handleHierarchyChange(val) {
    const {
      hierarchyId,
      locationState,
      filterAndSearchStateId,
      searchServiceUrl,
    } = this.props;
    const newHierarchyId = val ? val.value : null;
    if (!isEqual(hierarchyId, newHierarchyId)) {
      // change hierarchy and reset page
      const params = {
        hierarchyId: newHierarchyId,
        page: 1,
        parentHierarchyId: undefined,
      };
      // change component state
      this.debouncedChangeParamsAndQuery(
        filterAndSearchStateId,
        searchServiceUrl,
        params
      );

      // change location state
      this.props.changeParams(
        locationContainer.LOCATION_REDUCER_STATE_ID,
        params,
        locationState.reload,
        false,
        filterAndSearchStateId
      );
    }
  }

  render() {
    const {hierarchyId, hierarchyTypes} = this.props;
    return (
      <SelectHierarchyBox
        hierarchyId={hierarchyId}
        hierarchyTypes={hierarchyTypes}
        changeHierarchy={this.handleHierarchyChange}
      />
    );
  }
}

SelectHierarchyContainer.displayName = 'SelectHierarchyContainer';

SelectHierarchyContainer.propTypes = {
  filterAndSearchStateId: PropTypes.string.isRequired,
  hierarchyStateId: PropTypes.string.isRequired,
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  searchServiceUrl: PropTypes.string.isRequired,
};

export default connect(
  (state, props) => ({
    hierarchyTypes: state[props.hierarchyStateId].hierarchyTypes,
    locationState: state[props.hierarchyStateId].locationState,
    hierarchyId:
      state[props.filterAndSearchStateId].queryParameters.hierarchyId,
    searchServiceUrl: getSearchServiceUrl(state, props),
  }),
  {
    changeParams: locationContainer.changeParams,
    changeParamsAndQuery,
    getHierarchyTypes,
    loadStateFromParamsSelector,
  }
)(SelectHierarchyContainer);
